import { jsx as _jsx } from "react/jsx-runtime";
import { TreeItem2 } from '@mui/x-tree-view';
import { useContext, useEffect, useState } from 'react';
import { AppMainViewContext } from '../../../ContextProviders/AppContextProvider';
import { ObjectTree } from '../../../v2/components/generic/ObjectTree';
import { NavigationSkeleton } from '../../common/NavigationSkeleton';
import { getSingleTypeRecursivePath } from '../../EnititySupport/RecusiveEntityGroup/getRecursiveQueryPath';
const debug = process.env.REACT_APP_DEBUG && false;
const GROUPER_TYPE = 'Region';
const containedObjectType = 'Entity';
const x = () => {
    const subpaths = getSingleTypeRecursivePath({
        groupObjectType: GROUPER_TYPE,
        containedObjectType,
    });
    return subpaths;
};
export const useRegionQuery = () => {
    const [{ contextCustomer }] = useContext(AppMainViewContext);
    const [objectTreeQueryPath, setObjectTreeQueryPath] = useState(null);
    useEffect(() => {
        if (contextCustomer) {
            setObjectTreeQueryPath(x());
        }
    }, [contextCustomer?.sk]);
    return { objectTreeQueryPath };
};
export const Region = ({ applicationData, contextCustomer, transactionFunctions, lastKey }) => {
    const key = `${lastKey}_Region`;
    const topLevelRegions = applicationData?.getApexNodes().filter((node) => node.type === 'Region') ?? [];
    const { objectTreeQueryPath: RegionQuery } = useRegionQuery();
    return (_jsx(TreeItem2, { itemId: key, label: "Regions", children: contextCustomer !== undefined && applicationData !== undefined && RegionQuery !== null ? (_jsx(ObjectTree, { nodeEdgeMapper: applicationData,
            queryPaths: RegionQuery,
            contextObjects: topLevelRegions,
            transactionFunctions,
            hideTopStep: false,
            selectedNodeIds: [],
            expanded: [],
            orderByName: true,
            maxVisibleNodes: 10 }, key)) : (_jsx(NavigationSkeleton, {}, `admin_region`)) }, key));
};
